export default __webpack_public_path__ + "static/media/element_10.1bed2ba0.webp";